// =============================================================================
// Child theme entry — S.MART client behaviors.
// The parent theme (ai-zippy) handles core commerce behaviors (mini-cart,
// add to cart, wishlist, shop filter); this file only adds chrome behaviors.
// =============================================================================

document.addEventListener("DOMContentLoaded", () => {
  // Hamburger — MANDATORY even when the design has no mobile mockup
  const toggle = document.querySelector(".sm-header__toggle");
  const nav = document.querySelector(".sm-header__nav");
  if (toggle && nav) {
    const set = (open) => {
      nav.classList.toggle("is-open", open);
      toggle.classList.toggle("is-open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    };
    toggle.addEventListener("click", () => set(!nav.classList.contains("is-open")));
    nav.addEventListener("click", (e) => {
      if (e.target.closest("a")) set(false);
    });
  }

  // Nav active state — static links, so match by pathname
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  document.querySelectorAll(".sm-header__nav a").forEach((a) => {
    const href = a.getAttribute("href").replace(/\/+$/, "") || "/";
    const active =
      href === path || (href !== "/" && path.startsWith(href + "/")) || (href !== "/" && path === href);
    a.classList.toggle("is-active", active);
  });
});
